// ── MapLibre source/layer IDs ────────────────────────────────────────────────
// Centralised here so layer ordering is easy to track at a glance and there's
// no risk of typos between addLayer() and setPaintProperty() calls.

export const REGION_SOURCE = 'regions';
export const REGION_FILL = 'regions-fill';
export const REGION_BORDER = 'regions-border';
export const REGION_HOVER = 'regions-hover';
export const REGION_LABEL = 'regions-label';
export const REGION_DIM = 'regions-dim';
export const REGION_HIGHLIGHT = 'regions-highlight';

export const PC_SOURCE = 'postcodes';
export const PC_LAYER = 'postcodes-circle';
export const PC_LABEL = 'postcodes-label';

export const PC_POLY_SOURCE = 'postcode-polygons';
export const PC_POLY_FILL = 'postcode-polygons-fill';
export const PC_POLY_BORDER = 'postcode-polygons-border';
export const PC_POLY_HOVER = 'postcode-polygons-hover';
export const PC_POLY_FOCUS_BORDER = 'postcode-polygons-focus-border';
export const PC_POLY_LABEL = 'postcode-polygons-label';
